import { render } from "./NavigationItem.vue?vue&type=template&id=3417cf40"
import script from "./NavigationItem.vue?vue&type=script&lang=js"
export * from "./NavigationItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/NavigationItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3417cf40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3417cf40', __exports__)) {
    api.reload('3417cf40', __exports__)
  }
  
  module.hot.accept("./NavigationItem.vue?vue&type=template&id=3417cf40", () => {
    api.rerender('3417cf40', render)
  })

}


export default __exports__